import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

const fallback = (value) => value || 'N/A';

export const formatPatientAutocompleteLabel = (patient = {}) => {
    const name = fallback(patient.patientName);
    const surname = fallback(patient.patientSurname);
    const identifier = patient.clinicPatientId || patient.patientEmail || patient.patientId || 'N/A';

    return `${name} | ${surname} | ${identifier}`;
};

export const formatPatientAutocompleteSearchText = (patient = {}) =>
    [
        patient.patientName,
        patient.patientSurname,
        patient.patientEmail,
        patient.clinicPatientId,
        patient.patientStatus,
    ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

export const patientAutocompleteSx = {
    '& .MuiAutocomplete-inputRoot': {
        flexWrap: 'nowrap',
    },
    '& .MuiAutocomplete-input': {
        minWidth: '0 !important',
    },
};

export const patientAutocompleteNoOptionsText = 'No patients found';

export const renderPatientAutocompleteOption = (props, patient = {}, state = {}) => {
    const { key, ...optionProps } = props;
    const patientName = fallback(patient.patientName);
    const patientSurname = fallback(patient.patientSurname);
    const identifiers = [
        patient.patientEmail ? `Email ${patient.patientEmail}` : null,
        patient.clinicPatientId ? `PMS ID ${patient.clinicPatientId}` : null,
    ]
        .filter(Boolean)
        .join(' | ');
    const details = identifiers || 'N/A';
    const tooltipTitle = `${patientName} | ${patientSurname} | ${details}`;
    const optionKeyBase =
        patient.patientId || patient.clinicPatientId || patient.patientEmail || key || tooltipTitle;
    const optionKey = `${optionKeyBase}-${state.index ?? 'option'}`;

    return (
        <Tooltip
            key={optionKey}
            title={<span className="mp-mask-patient">{tooltipTitle}</span>}
            placement="right"
            arrow
            enterDelay={500}
        >
            <Box
                component="li"
                {...optionProps}
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: { xs: '3px', sm: '8px' },
                    minWidth: 0,
                    maxWidth: '100%',
                    py: { xs: '10px !important', sm: '8px !important' },
                    px: '16px !important',
                    textAlign: 'left',
                }}
            >
                <Typography
                    component="span"
                    className="mp-mask-patient"
                    noWrap
                    sx={{
                        flex: '0 1 auto',
                        minWidth: 0,
                        width: { xs: '100%', sm: 'auto' },
                        maxWidth: '100%',
                        color: '#202020',
                        fontSize: { xs: '14px', sm: '14px' },
                        lineHeight: { xs: '18px', sm: '20px' },
                        fontWeight: 500,
                        textAlign: 'left',
                    }}
                >
                    {patientName} | {patientSurname}
                </Typography>
                <Typography
                    component="span"
                    className="mp-mask-patient"
                    sx={{
                        flex: '1 1 auto',
                        minWidth: 0,
                        width: { xs: '100%', sm: 'auto' },
                        maxWidth: '100%',
                        color: '#616063',
                        fontSize: { xs: '12px', sm: '13px' },
                        lineHeight: { xs: '16px', sm: '20px' },
                        textAlign: 'left',
                        display: '-webkit-box',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: { xs: 2, sm: 1 },
                    }}
                >
                    {details}
                </Typography>
            </Box>
        </Tooltip>
    );
};
